const CALLS_LAYER = 'CallsLayer';
/**
 * Creates singleton storage for layer data - designed to be used with DeckGL.
 * Since DeckGL uses a reactive pattern, the layers array needs to be set with
 * a new array and layer instances for every change. DeckGL internally optimizes
 * renders using its own diffing mechanism. Use this store to keep all layers
 * needed to draw a single visualization.
 */
const storeLayers = () => {
  let index = 0;
  const store = {};

  return {
    /**
     * Return all of the internal state in the store.
     */
    get() {
      return store;
    },

    /**
     * Get all layers in the store sorted in the order they were added.
     *
     * Note:
     * The sorting is done in `DeckOverlay`
     */
    getAll() {
      const sorted = Object.values(store)
        .sort((b, a) => {
          if ([a.layer.id].includes(CALLS_LAYER)) {
            return 0;
          } else if ([b.layer.id].includes(CALLS_LAYER)) {
            return -1;
          }
          return (a?.index || 0) - (b?.index || 0);
        })
        .map(o => o?.layer)
        .filter(o => Boolean(o));
      return [...sorted];
    },

    /**
     * Save a layer to the store.
     * @param {number} id
     * @param {DeckGL.Layer} layer
     */
    save(layer) {
      const id = layer?.id;
      if (!id) {
        if (console && console.warn) {
          console.warn('Layer must have an id to be saved to the store.');
        }
        return;
      }
      if (!store[id]) {
        index += 1;
        store[id] = { index, layer };
      } else {
        const prev = store[id];
        store[id] = { index: prev.index, layer };
      }
    },

    /**
     * Save a list of layers to the store.
     * @param {number} id
     * @param {DeckGL.Layer} layer
     */
    saveGroup(layers) {
      layers.forEach(layer => {
        this.save(layer);
      });
    },

    deleteLayer(layerID) {
      if (store[layerID]) {
        delete store[layerID];
      }
    },
  };
};

export default storeLayers();
